import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

import { GoalsRoutingModule } from './goals-routing.module';
import { PlanProgressorMonitorComponent } from './plan-progressor-monitor/plan-progressor-monitor.component';
import { ObjectivesCatalogComponent } from './objectives-catalog/objectives-catalog.component';
import { UserObjectivesListComponent } from './user-objectives-list/user-objectives-list.component';
import { GoalsListComponent } from './goals-list/goals-list.component';
import { UnassignedReferralsComponent } from './unassigned-referrals/unassigned-referrals.component';

@NgModule({
  declarations: [
    PlanProgressorMonitorComponent,
    ObjectivesCatalogComponent,
    UserObjectivesListComponent,
    GoalsListComponent,
    UnassignedReferralsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    GoalsRoutingModule,
    NzCardModule,
    NzTableModule,
    NzTagModule,
    NzButtonModule,
    NzInputModule,
    NzCheckboxModule,
    NzSelectModule,
    NzModalModule,
    NzDropDownModule,
    NzIconModule,
    NzDatePickerModule,
  ],
})
export class GoalsModule {}
